import { Segmented } from "antd";
import styled from "styled-components";

export const StyledTabs = styled(Segmented)<{ $maxWidth?: string }>`
    max-width: ${(props) => props.$maxWidth};
    background: ${(props) => props.theme.tabsAPBackground};
    padding: 6px;
    border-radius: 8px;
    animation: none;

    .ant-segmented-item {
        border-radius: 8px;
        padding: 8px;
    }

    .ant-segmented-item-disabled {
        opacity: 0.5;
    }

    .ant-segmented-item-selected {
        background: ${(props) => props.theme.activeTabAPBackground};

        .ant-segmented-item-label {
            color: ${(props) => props.theme.activeTabColor} !important;
        }
    }

    .ant-segmented-item-label {
        color: ${(props) => props.theme.inactiveTabColor};
        padding: 0;
        min-height: auto;
        line-height: 120%;
        font-size: 14px;
    }

    .ant-segmented-thumb {
        border-radius: 8px;
        background: ${(props) => props.theme.activeTabAPBackground};
    }
`;

export const StyledTab = styled.span`
    display: flex;
    align-items: center;
    gap: 6px;
`;

export const StyledTabCount = styled.span`
    background: ${({ theme }) => theme.additionalTypographyColor};
    color: ${({ theme }) => theme.colors.white};
    border-radius: 999px;
    padding: 0 6px;
    font-size: 12px;
    font-weight: 500;
    min-width: 20px;
    text-align: center;
    line-height: 20px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
`;
